import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { generateNewsSlug, getNewsOccurrence } from '../utils/petSlug';

function NewsCard({ post, lang, allNews = [] }) {
  const { t, i18n } = useTranslation();

  const title = lang === 'en' ? post.title_en : post.title_bs;
  const excerpt = lang === 'en' ? post.excerpt_en : post.excerpt_bs;

  // Parsiranje datuma
  const dateObj = post.date ? new Date(post.date) : null;
  const day = dateObj?.getDate();
  const year = dateObj?.getFullYear();
  const monthName = dateObj
    ? t(
        `common.months.${dateObj.toLocaleString('en-US', { month: 'long' }).toLowerCase()}`
      )
    : '';

  return (
    <div className="card blog-card mb-4">
      {/* Datum */}
      <div className="post-info border-irregular2 text-muted">
        {' '}{monthName} {day}, {year}
      </div>

      {/* Slika */}
      <Link
        to={
          i18n.language === 'bs'
            ? `/news/${generateNewsSlug(title, getNewsOccurrence(post, allNews, lang))}`
            : `/${i18n.language}/news/${generateNewsSlug(title, getNewsOccurrence(post, allNews, lang))}`
        }
        state={{ post }}
        style={{ textDecoration: 'none' }}
      >
        <div className="card-img-top-wrapper">
          <img className="card-img-top img-fluid" src={post.img} alt={title} />
        </div>
      </Link>

      <div className="card-body">
        {/* Naslov */}
        <Link
          to={
            i18n.language === 'bs'
              ? `/news/${generateNewsSlug(title, getNewsOccurrence(post, allNews, lang))}`
              : `/${i18n.language}/news/${generateNewsSlug(title, getNewsOccurrence(post, allNews, lang))}`
          }
          state={{ post }}
          className="text-decoration-none"
        >
          <h3 className="card-title">{title}</h3>
        </Link>

        {/* Excerpt */}
        <p className="card-text mt-3">{excerpt}</p>

        {/* Dugme */}
        <Link
          to={
            i18n.language === 'bs'
              ? `/news/${generateNewsSlug(title, getNewsOccurrence(post, allNews, lang))}`
              : `/${i18n.language}/news/${generateNewsSlug(title, getNewsOccurrence(post, allNews, lang))}`
          }
          state={{ post }}
          className="btn btn-primary"
          style={{ textDecoration: 'none' }}
        >
          {t('common.readMore')}
        </Link>
      </div>
    </div>
  );
}

export default NewsCard;
